import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { ReactNode, SyntheticEvent, useState } from 'react'
import { SingleBoatDashboard } from '../SingleBoatDashboard'
import SingleBoatChartView from './SingleBoatChartView'
import CustomChartView from './CustomChartView'
import TripsView from './TripsView'
import PowerLinkView from './PowerLinkView'
import CCPView from './CCPView'

interface TabPanelProps {
    children?: ReactNode
    index: number
    value: number
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    )
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

export const SingleBoatChartViewTabs = ({ row, data }) => {
    const [value, setValue] = useState(0)

    const handleChange = (event: SyntheticEvent, newValue: number) => {
        setValue(newValue)
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="Single Vessle Dashboard"
                >
                    <Tab label="Diagnostics" {...a11yProps(0)} />
                    <Tab label="Trips" {...a11yProps(1)} />
                    {
                        //<Tab label="Vitals" {...a11yProps(2)} />
                    }
                    <Tab label="Chart Builder" {...a11yProps(3)} />
                    <Tab label="PowerLink" {...a11yProps(4)} />
                    <Tab label="Histograms" {...a11yProps(5)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <SingleBoatDashboard socketData={data} row={row} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <TripsView row={row} />
            </CustomTabPanel>
            {
                //<CustomTabPanel value={value} index={2}>
                //<SingleBoatChartView row={row} />
                //</CustomTabPanel>
            }
            <CustomTabPanel value={value} index={2}>
                <CustomChartView row={row} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
                <PowerLinkView row={row} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
                <CCPView row={row} />
            </CustomTabPanel>
        </Box>
    )
}
